import { useState, useMemo } from "react";

const allCities = [
  { name: "Manchester", route: "/manchester", tagline: "New Hampshire's largest city expedited passport services", highlights: ["Manchester-Boston Regional Airport nearby", "Serving Merrimack, Hooksett, Goffstown"], badge: "Most Popular", status: "live" },
  { name: "Nashua", route: "/nashua", tagline: "Southern New Hampshire expedited passport processing", highlights: ["Nashua area coverage", "Serving Hudson, Merrimack, Pelham"], badge: "Most Popular", status: "live" },
  { name: "Concord", route: "/concord-nh", tagline: "Capital city expedited passport services", highlights: ["Concord area coverage", "Serving Bow, Pembroke, Loudon"], badge: null, status: "live" },
  { name: "Portsmouth", route: "/portsmouth", tagline: "Seacoast New Hampshire passport courier service", highlights: ["Portsmouth area coverage", "Serving Dover, Hampton, Exeter"], badge: null, status: "live" },
  { name: "Dover", route: "/dover", tagline: "Strafford County expedited passport services", highlights: ["Dover area coverage", "Serving Somersworth, Rochester"], badge: null, status: "live" },
  { name: "Rochester", route: "/rochester", tagline: "Strafford County passport processing", highlights: ["Rochester area coverage", "Serving Dover, Somersworth"], badge: null, status: "live" },
  { name: "Keene", route: "/keene", tagline: "Monadnock Region expedited passport services", highlights: ["Keene area coverage", "Serving Peterborough, Jaffrey, Hinsdale"], badge: null, status: "live" },
  { name: "Laconia", route: "/laconia", tagline: "Lakes Region expedited passport services", highlights: ["Laconia area coverage", "Serving Gilford, Belmont, Meredith"], badge: null, status: "live" },
  { name: "Lebanon", route: "/lebanon", tagline: "Upper Valley expedited passport processing", highlights: ["Lebanon area coverage", "Serving Hanover, Claremont, Enfield"], badge: null, status: "live" },
  { name: "Claremont", route: "/claremont", tagline: "Sullivan County expedited passport services", highlights: ["Claremont area coverage", "Serving Newport, Charlestown"], badge: null, status: "live" },
  { name: "Somersworth", route: "/somersworth", tagline: "Strafford County passport services", highlights: ["Somersworth area coverage", "Serving Dover, Rollinsford"], badge: null, status: "live" },
  { name: "Franklin", route: "/franklin-nh", tagline: "Merrimack County expedited passport services", highlights: ["Franklin area coverage", "Serving Tilton, Northfield"], badge: null, status: "live" },
  { name: "Berlin", route: "/berlin", tagline: "North Country expedited passport processing", highlights: ["Berlin area coverage", "Serving Gorham, Milan, White Mountains"], badge: null, status: "live" },
  { name: "Derry", route: "/derry", tagline: "Rockingham County passport services", highlights: ["Derry area coverage", "Serving Londonderry, Salem, Windham"], badge: null, status: "live" },
  { name: "Merrimack", route: "/merrimack", tagline: "Merrimack County expedited passport services", highlights: ["Merrimack area coverage", "Serving Nashua, Bedford, Amherst"], badge: null, status: "live" },
  { name: "Hudson", route: "/hudson", tagline: "Southern New Hampshire passport services", highlights: ["Hudson area coverage", "Serving Nashua, Litchfield"], badge: null, status: "live" },
  { name: "Londonderry", route: "/londonderry", tagline: "Rockingham County expedited passport services", highlights: ["Londonderry area coverage", "Serving Derry, Windham, Salem"], badge: null, status: "live" },
  { name: "Hampton", route: "/hampton", tagline: "Seacoast New Hampshire passport services", highlights: ["Hampton area coverage", "Serving Exeter, Portsmouth, Seabrook"], badge: null, status: "live" },
  { name: "Exeter", route: "/exeter", tagline: "Rockingham County expedited passport services", highlights: ["Exeter area coverage", "Serving Stratham, Hampton, Newmarket"], badge: null, status: "live" },
  { name: "Hooksett", route: "/hooksett", tagline: "Merrimack County passport services", highlights: ["Hooksett area coverage", "Serving Manchester, Concord, Bow"], badge: null, status: "live" },
  { name: "Goffstown", route: "/goffstown", tagline: "Hillsborough County expedited passport services", highlights: ["Goffstown area coverage", "Serving Manchester, Bedford, Weare"], badge: null, status: "live" },
  { name: "Windham", route: "/windham-nh", tagline: "Rockingham County passport processing", highlights: ["Windham area coverage", "Serving Derry, Salem, Pelham"], badge: null, status: "live" },
  { name: "Pelham", route: "/pelham", tagline: "Southern New Hampshire passport services", highlights: ["Pelham area coverage", "Serving Windham, Salem, Hudson"], badge: null, status: "live" },
  { name: "Raymond", route: "/raymond", tagline: "Rockingham County expedited passport services", highlights: ["Raymond area coverage", "Serving Epping, Derry, Nottingham"], badge: null, status: "live" },
  { name: "Milford", route: "/milford-nh", tagline: "Hillsborough County passport services", highlights: ["Milford area coverage", "Serving Amherst, Wilton, Mont Vernon"], badge: null, status: "live" },
  { name: "Hanover", route: "/hanover", tagline: "Upper Valley expedited passport services", highlights: ["Hanover area coverage", "Dartmouth College area", "Serving Lebanon, Norwich VT"], badge: null, status: "live" },
  { name: "Durham", route: "/durham-nh", tagline: "Seacoast New Hampshire passport processing", highlights: ["Durham area coverage", "UNH area", "Serving Dover, Newmarket"], badge: null, status: "live" },
  { name: "Newmarket", route: "/newmarket", tagline: "Rockingham County passport services", highlights: ["Newmarket area coverage", "Serving Durham, Exeter, Epping"], badge: null, status: "live" },
  { name: "Conway", route: "/conway-nh", tagline: "Mount Washington Valley expedited passport services", highlights: ["Conway area coverage", "White Mountains gateway", "Serving North Conway, Bartlett"], badge: null, status: "live" },
  { name: "Wolfeboro", route: "/wolfeboro", tagline: "Lakes Region passport services", highlights: ["Wolfeboro area coverage", "Lake Winnipesaukee area", "Serving Tuftonboro, Alton"], badge: null, status: "live" },
  { name: "Littleton", route: "/littleton-nh", tagline: "North Country expedited passport services", highlights: ["Littleton area coverage", "Serving Bethlehem, Whitefield, Lisbon"], badge: null, status: "live" },
  { name: "Lancaster", route: "/lancaster-nh", tagline: "Northern New Hampshire passport services", highlights: ["Lancaster area coverage", "Serving Groveton, Jefferson, Whitefield"], badge: null, status: "live" },
  { name: "Plymouth", route: "/plymouth", tagline: "Central New Hampshire expedited passport services", highlights: ["Plymouth area coverage", "PSU area", "Serving Holderness, Rumney, Ashland"], badge: null, status: "live" },
  { name: "Henniker", route: "/henniker", tagline: "Merrimack County passport services", highlights: ["Henniker area coverage", "NEC area", "Serving Hillsborough, Bradford, Warner"], badge: null, status: "live" },
  { name: "Jaffrey", route: "/jaffrey", tagline: "Monadnock Region expedited passport services", highlights: ["Jaffrey area coverage", "Mount Monadnock area", "Serving Peterborough, Rindge"], badge: null, status: "live" },
  { name: "Peterborough", route: "/peterborough", tagline: "Monadnock Region passport services", highlights: ["Peterborough area coverage", "Serving Dublin, Jaffrey, Hancock"], badge: null, status: "live" },
];

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");

export default function NewHampshireCitiesDirectory() {
  const [activeLetter, setActiveLetter] = useState<string | null>(null);
  const [searchQuery, setSearchQuery] = useState("");

  const lettersWithCities = useMemo(() => {
    const set = new Set<string>();
    allCities.forEach((c) => set.add(c.name[0].toUpperCase()));
    return set;
  }, []);

  const filteredCities = useMemo(() => {
    let result = allCities;
    if (activeLetter) {
      result = result.filter((c) => c.name[0].toUpperCase() === activeLetter);
    }
    if (searchQuery.trim()) {
      const q = searchQuery.toLowerCase();
      result = result.filter(
        (c) =>
          c.name.toLowerCase().includes(q) ||
          c.tagline.toLowerCase().includes(q) ||
          c.highlights.some((h) => h.toLowerCase().includes(q))
      );
    }
    return result;
  }, [activeLetter, searchQuery]);

  const liveCount = allCities.filter((c) => c.status === "live").length;
  const comingCount = allCities.filter((c) => c.status === "coming").length;

  return (
    <section id="cities" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">
            New Hampshire Cities
          </p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Choose Your New Hampshire Location
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed mb-2">
            Select your city to view local acceptance facilities, processing options, and
            expedited services tailored to your area.
          </p>
          <p className="text-gray-400 text-sm">
            <span className="text-[#1A365D] font-semibold">{liveCount}</span> cities live
            &nbsp;&middot;&nbsp;
            <span className="text-[#1A365D] font-semibold">{comingCount}</span> more coming
            soon
          </p>
        </div>

        <div className="max-w-xl mx-auto mb-6">
          <div className="relative">
            <div className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
              <i className="ri-search-line text-gray-400"></i>
            </div>
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                if (e.target.value.trim() && activeLetter) setActiveLetter(null);
              }}
              placeholder="Search cities..."
              className="w-full pl-11 pr-10 py-3 bg-white border border-gray-200 rounded-lg text-sm text-[#1A365D] placeholder:text-gray-400 focus:outline-none focus:border-[#F6C344] focus:ring-1 focus:ring-[#F6C344] transition-all"
            />
            {searchQuery && (
              <button
                onClick={() => setSearchQuery("")}
                className="absolute right-3 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center text-gray-400 hover:text-gray-600"
              >
                <i className="ri-close-line"></i>
              </button>
            )}
          </div>
        </div>

        <div className="max-w-4xl mx-auto mb-12">
          <div className="flex flex-wrap items-center justify-center gap-1.5 md:gap-2">
            <button
              onClick={() => setActiveLetter(null)}
              className={`px-3 py-1.5 rounded-md text-sm font-semibold transition-all whitespace-nowrap ${
                activeLetter === null
                  ? "bg-[#1A365D] text-white"
                  : "bg-white text-gray-500 hover:bg-[#EEF2F8] hover:text-[#1A365D] border border-gray-200"
              }`}
            >
              All
            </button>
            {LETTERS.map((letter) => {
              const hasCities = lettersWithCities.has(letter);
              const isActive = activeLetter === letter;
              return (
                <button
                  key={letter}
                  onClick={() => hasCities && setActiveLetter(isActive ? null : letter)}
                  disabled={!hasCities}
                  className={`w-8 h-8 md:w-9 md:h-9 rounded-md text-sm font-semibold flex items-center justify-center transition-all ${
                    isActive
                      ? "bg-[#1A365D] text-white"
                      : hasCities
                        ? "bg-white text-[#1A365D] hover:bg-[#EEF2F8] border border-gray-200 cursor-pointer"
                        : "bg-gray-100 text-gray-300 border border-gray-100 cursor-not-allowed"
                  }`}
                >
                  {letter}
                </button>
              );
            })}
          </div>
        </div>

        {(activeLetter || searchQuery) && (
          <div className="flex items-center justify-between max-w-7xl mb-6">
            <p className="text-sm text-gray-500">
              Showing{" "}
              <span className="font-semibold text-[#1A365D]">{filteredCities.length}</span>{" "}
              {filteredCities.length === 1 ? "city" : "cities"}
              {activeLetter && (
                <>
                  {" "}
                  starting with <span className="font-semibold text-[#1A365D]">{activeLetter}</span>
                </>
              )}
              {searchQuery && (
                <>
                  {" "}
                  matching <span className="font-semibold text-[#1A365D]">&quot;{searchQuery}&quot;</span>
                </>
              )}
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="text-sm text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors whitespace-nowrap"
            >
              Clear filters
            </button>
          </div>
        )}

        {filteredCities.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredCities.map((city, i) =>
              city.status === "live" ? (
                <a
                  key={i}
                  href={city.route}
                  className="group relative bg-white border border-gray-200 rounded-lg p-7 hover:border-[#F6C344] transition-all duration-200 flex flex-col"
                >
                  {city.badge && (
                    <span className="absolute top-4 right-4 bg-[#1A365D] text-white text-xs font-semibold px-2.5 py-1 rounded-full whitespace-nowrap">
                      {city.badge}
                    </span>
                  )}
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                      <i className="ri-map-pin-2-line text-[#1A365D] text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-[#1A365D] text-lg">{city.name}</h3>
                      <p className="text-gray-400 text-xs">New Hampshire</p>
                    </div>
                  </div>
                  <p className="text-gray-500 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-600">
                        <i className="ri-check-line text-[#F6C344] flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-sm group-hover:text-[#F6C344] transition-colors mt-auto whitespace-nowrap">
                    View Services{" "}
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </div>
                </a>
              ) : (
                <div
                  key={i}
                  className="group relative bg-white border border-dashed border-gray-300 rounded-lg p-7 flex flex-col"
                >
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gray-100 flex-shrink-0">
                      <i className="ri-time-line text-gray-400 text-xl"></i>
                    </div>
                    <div>
                      <h3 className="font-bold text-gray-400 text-lg">{city.name}</h3>
                      <span className="inline-block bg-gray-100 text-gray-500 text-xs font-semibold px-2 py-0.5 rounded-full mt-0.5">
                        Coming Soon
                      </span>
                    </div>
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed mb-4">{city.tagline}</p>
                  <ul className="space-y-2 mb-6 flex-1">
                    {city.highlights.map((h, j) => (
                      <li key={j} className="flex items-center gap-2 text-sm text-gray-400">
                        <i className="ri-check-line text-gray-300 flex-shrink-0"></i>
                        {h}
                      </li>
                    ))}
                  </ul>
                  <div className="inline-flex items-center gap-1.5 text-gray-400 font-semibold text-sm mt-auto whitespace-nowrap">
                    Coming Soon <i className="ri-time-line"></i>
                  </div>
                </div>
              )
            )}
          </div>
        ) : (
          <div className="text-center py-16">
            <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#EEF2F8] mx-auto mb-4">
              <i className="ri-search-line text-[#1A365D] text-2xl"></i>
            </div>
            <h3 className="font-bold text-[#1A365D] text-lg mb-2">No cities found</h3>
            <p className="text-gray-500 text-sm max-w-md mx-auto">
              Try a different search term or letter. We&apos;re always adding new New Hampshire locations.
            </p>
            <button
              onClick={() => {
                setActiveLetter(null);
                setSearchQuery("");
              }}
              className="mt-4 inline-flex items-center gap-1.5 text-[#1A365D] hover:text-[#F6C344] font-semibold text-sm transition-colors whitespace-nowrap"
            >
              Show all cities <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        )}
      </div>
    </section>
  );
}